import { CSSObject, FlattenSimpleInterpolation, css } from 'styled-components'

export const getFlexCSS = (
  flex: CSSObject['flex']
): FlattenSimpleInterpolation => {
  return css`
    flex: ${flex};
  `
}

export const getVisibleCSS = (): FlattenSimpleInterpolation => {
  return css`
    & {
      display: none;
    }
  `
}
